export class ColorUtils {
  private static hexToRgb(hex: string) {
    const match = hex.trim().match(/^#?([a-fA-F0-9]{3}|[a-fA-F0-9]{6})$/);
    if (!match) throw new Error(`Invalid hex color: "${hex}"`);
    let h = match[1];
    if (h.length === 3)
      h = h
        .split('')
        .map((c) => c + c)
        .join('');
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    return { r, g, b };
  }

  private static getBrightness(r: number, g: number, b: number) {
    return (r * 299 + g * 587 + b * 114) / 1000;
  }

  public static getContrastTextColor(hexColor: string) {
    const { r, g, b } = this.hexToRgb(hexColor);
    const brightness = this.getBrightness(r, g, b);

    return brightness >= 128
      ? 'var(--ds-color-neutral-text-default)'
      : 'var(--ds-color-neutral-base-contrast-default)';
  }
}
